import { Button } from 'devextreme-react/button';
import { Item, Toolbar } from 'devextreme-react/toolbar';
import DataGrid, { Column, Paging } from 'devextreme-react/data-grid';
import { useContext, useState } from 'react';
import { FileTypes, KindOfOrder } from '../../../../types/enums';
import { FileAttachmentLink, FileAttachmentsPopup } from '../../../common';
import { RefetchScope, WorkOrderContext } from '../context/WorkOrderContext';

export default function WorkOrderFiles(props: {
	fileTypes: FileTypes[],
	buttonCaption?: string,
	onFileAdded?: (fileType: FileTypes) => void
}
) {

	const { order, refetchOrder } = useContext(WorkOrderContext);
	const [isPopupVisible, setPopupVisibility] = useState(false);

	return (
		<>
			<>
				{
					!!props.buttonCaption &&
					<>
						<Toolbar className='button-toolbar'>
							<Item location={'before'} >
								<Button
									width={220}
									text={props.buttonCaption}
									icon="Inscyth-Add"
									onClick={() => setPopupVisibility(true)}>
								</Button>
							</Item>
						</Toolbar>

						<FileAttachmentsPopup
							attachedFiles={order.details.files}
							orderID={order.details.workOrderID}
							parentGuid={order.details.guid}
							kindOfOrder={KindOfOrder.WorkOrder}
							fileTypeFilter={(fileType: FileTypes) => { return props.fileTypes.includes(fileType) }}
							defaultFileType={props.fileTypes[0]}
							useFileTypes={true}
							onFileAdded={(fileType: FileTypes) => {
								refetchOrder(RefetchScope.Files);

								if (props.onFileAdded) {
									props.onFileAdded(fileType);
								}

								if (props.fileTypes.includes(fileType)) {
									setPopupVisibility(false);
								}
							}}
							onFileDeleted={() => refetchOrder(RefetchScope.Files)}
							onPopupHidden={() => setPopupVisibility(false)}
							visible={isPopupVisible}
							hideDeleteButton={true}
						/>
					</>
				}
			</>

			<DataGrid
				className='dx-card wide-card'
				dataSource={order.details.files.filter(x => props.fileTypes.includes(x.fileTypeID))}
				allowColumnResizing={true}
				showBorders={true}
				showColumnLines={true}
				columnAutoWidth={true}
				keyExpr={'documentID'}
			>
				<Paging enabled={false} />

				<Column
					caption={'File Name'}
					dataType="string"
					cellRender={(cell: any) => {
						return <FileAttachmentLink
							caption={cell.data.fileName}
							fileName={cell.data.fileName}
							awsS3Key={cell.data.awsS3Key} />
					}}
				>
				</Column>
				<Column
					dataField={'fileTypeName'}
					caption={'File Type'}
					dataType="string"
				/>
				<Column
					dataField={'uploadDate'}
					caption={'Upload Date'}
					dataType="date"
					format="shortDateShortTime"
				/>
				<Column
					dataField={'createdBy'}
					caption={'Created By'}
					dataType="string"
				/>
			</DataGrid>
		</>
	);
}
